// extracted by mini-css-extract-plugin
export default {"MyInput":"MyInput_MyInput__tmC1t"};